var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 34,
    viewBox: "0 0 56 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_10546",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8929 0.530396H43.4838C41.0337 0.530396 38.6698 1.44791 36.8485 3.10624L29.4541 9.83323C29.4541 9.83323 35.7991 10.1909 36.1104 15.1318C18.8251 18.5613 45.6752 26.3889 45.6752 26.3889C45.6752 26.3889 45.57 12.8668 50.6805 6.97639C50.8025 6.83589 51.0233 6.99129 50.9371 7.15734C46.9896 14.5783 48.0559 23.0169 48.0559 23.0169L54.7247 13.5671L54.8046 11.9365L54.9035 9.92052L55.362 0.530396H50.8929Z",
    fill: "#D71524"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9809 12.6177C23.6454 8.1749 20.5581 5.32869 18.7726 3.52348C16.8735 1.60756 14.3035 0.530388 11.6221 0.530388H7.46219C7.46219 0.530388 12.7535 3.98968 12.0301 4.9966C7.16776 -0.225335 0.637695 0.530388 0.637695 0.530388L1.30858 14.2292L10.5474 29.3543C10.5474 29.3543 11.5106 14.9934 5.59886 6.14402C5.50633 6.00778 5.69981 5.86089 5.80286 5.98862C13.0333 14.8465 12.8398 33.1052 12.8398 33.1052C12.8398 33.1052 16.6463 33.2989 21.1974 33.1052C20.4971 28.2516 13.4286 18.2654 28.9788 12.6198L28.9809 12.6177Z",
    fill: "#D71524"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5429 13.763C13.5395 20.5943 34.3727 33.1904 34.3727 33.1904H42.9511C42.9511 33.1904 14.1515 22.1888 30.5429 13.763Z",
    fill: "#D71524"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_10546)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.96387,
    y: -9.32196,
    width: 69.0947,
    height: 46.5117,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d8293d099e89c84ea43206294387e324.svg";
export { ForwardRef as ReactComponent };